import { render, staticRenderFns } from "./priceListConfigEditor.vue?vue&type=template&id=125a6b59&scoped=true&"
import script from "./priceListConfigEditor.vue?vue&type=script&lang=js&"
export * from "./priceListConfigEditor.vue?vue&type=script&lang=js&"
import style0 from "./priceListConfigEditor.vue?vue&type=style&index=0&id=125a6b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a6b59",
  null
  
)

export default component.exports